import Route from '@ember/routing/route';
import type RouterService from '@ember/routing/router-service';
import { service } from '@ember/service';
import type AbilitiesService from 'ember-can/services/abilities';
import type AuthzService from 'garaje/services/authz';
import type { Role } from 'garaje/utils/custom-roles';
import type { Matrix } from 'garaje/utils/permission-sets';

interface ModelParams {
  role_id: string;
}

export interface CreateRoleModel {
  role: Role;
  matrix: Matrix;
}

class ManageCreateRoleRoute extends Route {
  @service declare authz: AuthzService;
  @service declare router: RouterService;
  @service declare abilities: AbilitiesService;

  titleToken = 'Create role';

  beforeModel(): void {
    if (this.abilities.cannot('create custom-roles')) {
      void this.router.transitionTo('unauthorized');
    }
  }

  async model({ role_id }: ModelParams): Promise<CreateRoleModel> {
    const matrix = await this.authz.fetchMatrix(role_id);
    const role = await this.authz.fetchRole(role_id);

    return { role: role!, matrix: matrix! };
  }
}

export default ManageCreateRoleRoute;
